import defaultStore from '../defaultStore'
import utils from '@/utils'

const { store } = defaultStore(`file`, utils.makeBackendRequestData)

export default {
  ...store,
}
